import PopulacaoService from '@/services/PopulacaoService';

export const populacao = {
    namespaced: true,
    actions: {
        buscarPopulacaoPorIdadeSexo () {
            return PopulacaoService.buscarPopulacaoPorIdadeSexo()
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        historicoAdmissaoDesligamento ({ dispatch }, { ultimosMeses }) {
            return PopulacaoService.historicoAdmissaoDesligamento({ ultimosMeses })
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        historicoAdmissaoPorSetor ({ dispatch }, { ultimosMeses }) {
            return PopulacaoService.historicoAdmissaoPorSetor({ ultimosMeses })
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        admissaoDesligamentoPorSetor () {
            return PopulacaoService.admissaoDesligamentoPorSetor()
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        totalAdmissaoPorRegiaoMacroMicro () {
            return PopulacaoService.totalAdmissaoPorRegiaoMacroMicro()
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
    },
    state: {},
    mutations: {},
};
